import { memoize, isFunction } from 'lodash'
import { action, makeObservable, observable } from 'mobx';
import * as utils from './utils'
import EventEmitter from '@utils/EventEmitter';

const _MOBILE_ = '3'
const _PC_ = '1'
const getContextMap = {
  '1': () => {
    if (isFunction(window.diworkContext)) {
      return window.diworkContext()
    }
    return window.__INITIAL_STATE__?.__GLOBALZITION__
  },
  '3': () => {
    return window.__INITIAL_STATE__?.__GLOBALZITION__
  }
}

let getContextByDevice = function getContextByDevice<Promise>(device: string = '1') {
  let context = getContextMap[device]()
  if (!context) {
    try {
      context = JSON.parse(localStorage.getItem('diworkContext'))
    } catch (err) {
      return
    }
  }
  return context
}

getContextByDevice = memoize(getContextByDevice)

export class BaseStore {
  contextReady = false
  ready = false
  willUnmount = false
  context = null
  utils = utils
  events = {};
  storeType: string = 'BaseStore'
  /**
   * TODO：lifecycle 更名为 eventBus。同步更新reaction代码
   * TODO：events\on\un\execute 去掉。同步更新reaction代码
   * TODO：
   *  1、rootStore.eventBus
      2、事件名按生命周期方式命名，具体的业务含义
      3、传入的参数，rootStore、source、params
      4、支持传是否async 异步的参数。
   */
  eventBus = new EventEmitter()
  /**
   *
   * 当前是否移动端
   * @type {boolean}
   * @memberof BaseStore
   */
  public isMobile?: boolean;
  /**
   *当前是否pc端
   *
   * @type {boolean}
   * @memberof BaseStore
   */
  public isPc?: boolean;
  constructor(props: any) {
    this.initContext(props)
    makeObservable(this, {
      ready: observable,
      willUnmount: observable,
      context: observable,
      contextReady: observable,
      initContext: action
    })
  }

  async initContext(props: any) {
    const { query } = props || {}
    const terminalType = query?.terminalType ?? '1'
    this.isMobile = terminalType == _MOBILE_
    this.isPc = terminalType == _PC_
    this.utils.setIsMobile(this.isMobile)
    try {
      const res = await getContextByDevice(terminalType)
      this.context = res
      this.contextReady = true
    } catch (error) {
    }
  }

  get(key: string) {
    return this[key]
  }

  // temp
  getStoreByAlias(alias: string) {
    const res = this[alias] ?? this[`${alias}Store`]
    if (!res) {
      console.error(`not found alias : ${alias}`);
    }
    return res
  }

  set(key: string, vaue: any) {
    this[key] = vaue
  }

  getPageInfoStore() {
    return this.findStoreByStoreType('PageInfo')
  }

  getFilterStore() {
    return this.findStoreByStoreType('FilterStore')
  }

  setUiState(mode: string) {
    for (const key in this) {
      if (this[key]?.storeType) {
        this[key].setUiState?.(mode)
      }
    }
  }

  getTableStore(key: string | undefined) {
    if (key) {
      return this.findStoreByKey(key);
    } else {
      return this.findStoreByStoreType('TableStore')
    }
  }

  getPagingStore() {
    return this.findStoreByStoreType('PagingStore')
  }

  getTreeStore(key: string | undefined) {
    if (key) {
      return this.findStoreByKey(key);
    } else {
      return this.findStoreByStoreType('TreeStore')
    }
  }

  findStoreByKey(key: string) {
    return this[key];
  }

  findStoreByStoreType(storeType: string) {
    for (const key in this) {
      if (this[key]?.storeType === storeType) {
        return this[key];
      }
    }
  }
}
